import { Serializer } from '@teem/generic/serializer';
import { Resource } from '@teem/generic/resource';
import * as moment from 'moment';

export class OrderSerializer implements Serializer {
  fromJson(json: any): Order {
    let order = new Order(json);
    return order;
  }

  toJson(order: Order): any {
  	return order;
  }
} 

export class Order implements Resource{
	public id:number;
	public uuid:string = null;
	public title: string; 
	public order_date: string;
	public order_type: string;
	public invoice_number: number = null;
	public order_number: number = null;
	public city: string;
	public district: string;
	public region: string;
	public total_amount: number = 0;
	public total_discount: number = 0;

	constructor(input?:any) {
		if(input){  
			Object.assign(this, input);
		}
	}
}